import { render, staticRenderFns } from "./StoreAdmins.vue?vue&type=template&id=3822f1ef&scoped=true&"
import script from "./StoreAdmins.vue?vue&type=script&lang=ts&"
export * from "./StoreAdmins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822f1ef",
  null
  
)

export default component.exports